export default () => ({
  isLoaded: false,

  original: null,
  modified: null
})
